import {
  singlePageDataFetcher,
  SinglePageTemplate,
} from "components/templates/SinglePage";

export default SinglePageTemplate;

export async function getServerSideProps(context) {
  const locale = context.locale;
  const query = {
    slug: context.query.slug,
    requestSlug: "news-category",
  };
  return await singlePageDataFetcher({ query, locale });
}
